import React from 'react';
import { Modal, Badge } from 'react-bootstrap';
import type { GlowpickProduct } from '../../../../models/Glowpick';
import { RankingIcon } from './Icons';

interface DescriptionModalProps {
  show: boolean;
  onHide: () => void;
  product: GlowpickProduct | null;
}

export const DescriptionModal: React.FC<DescriptionModalProps> = ({ show, onHide, product }) => {
  if (!product) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Description - {product.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* Product Description */}
          <div className="mb-4">
            <h6 className="fw-bold mb-2">Description</h6>
            <div className="text-wrap">
              {product.description?.split('\n').map((line, index) => (
                <p key={index} className="mb-2">
                  {line}
                </p>
              ))}
            </div>
          </div>

          {/* Tags */}
          {product.tags && product.tags.length > 0 && (
            <div className="mb-4">
              <h6 className="fw-bold mb-2">Tags</h6>
              <div className="d-flex flex-wrap gap-2">
                {product.tags.map((tag, index) => (
                  <Badge key={index} bg="light" text="dark">
                    #{tag}
                  </Badge>
                ))}
              </div>
            </div>
          )}

          {/* Size and Price */}
          <div className="mb-4">
            <h6 className="fw-bold mb-2">Size/Price</h6>
            <p className="mb-0">
              {product.size || 'N/A'} / {product.price?.toLocaleString() || 'N/A'}KRW
            </p>
          </div>

          {/* Category */}
          <div className="mb-4">
            <h6 className="fw-bold mb-2">Category</h6>
            <p className="mb-0">
              {product.subcategory ? `${product.category} > ${product.subcategory}` : product.category}
            </p>
          </div>

          {/* Rankings if available */}
          {((product.rankings?.brand && product.rankings.brand.ranking > 0) ||
            (product.rankings?.category && product.rankings.category.ranking > 0)) && (
            <div className="mb-4">
              <h6 className="fw-bold mb-2 d-flex align-items-center">
                <RankingIcon size={20} />
                <span className="ms-1">Ranking</span>
              </h6>
              <div className="d-flex flex-wrap gap-2">
                {product.rankings?.brand && product.rankings.brand.ranking > 0 && (
                  <Badge bg="light" text="muted">
                    {product.rankings.brand.title} {product.rankings.brand.ranking}위
                  </Badge>
                )}
                {product.rankings?.category && product.rankings.category.ranking > 0 && (
                  <Badge bg="light" text="muted">
                    {product.rankings.category.title} {product.rankings.category.ranking}위
                  </Badge>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
